import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

var ModalBody = function ModalBody(_ref) {
  var children = _ref.children,
      _ref$scrollable = _ref.scrollable,
      scrollable = _ref$scrollable === void 0 ? true : _ref$scrollable;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames("et--modal-body", {
      "et--modal-body-scrollable": scrollable
    })
  }, children);
};

ModalBody.propTypes = {
  children: PropTypes.any,
  scrollable: PropTypes.bool
};
export default ModalBody;